import { render, staticRenderFns } from "./MedicinesTypeBtns.vue?vue&type=template&id=a72e7434&"
import script from "./MedicinesTypeBtns.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypeBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports